export default __webpack_public_path__ + "static/media/slider1.5c31ed08.PNG";